/**
 * MaritalStatusService
 * Service for MaritalStatus entity operations
 * Route: api/marital-status
 * Controller: MaritalStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MaritalStatusService
 * Handles marital status CRUD operations (cached lookup table)
 * Maps to /api/marital-status endpoint
 */
export class MaritalStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MaritalStatusService.DEFAULT_SERVICE_PATH,
            basePath: MaritalStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MaritalStatusService.DEFAULT_SERVICE_PATH = 'members';
MaritalStatusService.BASE_PATH = 'api/marital-status';
//# sourceMappingURL=MaritalStatusService.js.map